/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import styled from "styled-components";
import { GuidePagePlayerBlock } from "./GuidePagePlayerBlock";
import { CmsPlayerAttributes } from "api/CmsApi";
import { NewRelicDecoratedError, noticeError } from "utilities/noticeError";

export class GuidePageCodeBlockParseError extends NewRelicDecoratedError {
  constructor(errorOrString: Error | string) {
    super(errorOrString);
    this.name = "GuidePageCodeBlockParseError";
  }
}

export const GuidePageCodeBlock: React.FC<{
  codeJson: string | undefined;
}> = ({ codeJson }) => {
  if (codeJson) {
    let codeAttributes;
    try {
      codeAttributes = JSON.parse(codeJson);
    } catch (error) {
      noticeError(new GuidePageCodeBlockParseError(error));
    }

    switch (codeAttributes?.type) {
      case "video":
      case "audio":
        return (
          <GuidePagePlayerBlock
            media={codeAttributes as CmsPlayerAttributes}
            type={codeAttributes.type}
          />
        );
      default:
        return <></>;
    }
  } else {
    return <></>;
  }
};
